import { memo } from 'react';

import dayjs from 'dayjs';

import { XYChart } from './xyChart';

export const XYChartLoader = memo(() => {
  const currentDate = dayjs();
  const last30DaysXValues = Array.from({ length: 30 }, (_, i) => {
    const date = currentDate.subtract(i, 'day');

    return date.toDate();
  });

  const data = [
    {
      data: last30DaysXValues.reverse().map((x) => ({ x, y: undefined })),
      dataKey: '',
    },
  ];

  return <XYChart data={data} />;
});
